export const Utils = {
	yes: "Y",
	no: "N"
}
